const ICONS = {
  globe: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M3 12h18M12 3a14 14 0 0 1 0 18 14 14 0 0 1 0-18',
  server:
    'M5 4h14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2M5 13h14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2M7 7.5h.01M7 16.5h.01',
  activity: 'M4 12h4l2.2-6 3.6 12 2.2-6H20',
  send: 'M5 12h13M13 6l6 6-6 6',
  external: 'M14 5h5v5M19 5l-8 8M18 13v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5',
  bolt: 'M13 3 5 14h6l-1 7 8-11h-6l1-7Z',
  chat: 'M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9l-5 4V6ZM8 9h8M8 12h5',
  watch: 'M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  shield: 'M12 3 4.5 6v6c0 4.2 3.1 7.6 7.5 9 4.4-1.4 7.5-4.8 7.5-9V6L12 3ZM9 12l2 2 4-4',
  pin: 'M8 4h8l-1 5 3 3v1H6v-1l3-3-1-5ZM12 13v7',
  users: 'M16 20v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 18.5V20M10 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM17 8a3 3 0 0 1 0 6M18 15a3.5 3.5 0 0 1 2 3.2V20',
  user: 'M12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM4 21a8 8 0 0 1 16 0',
};

export function Icon({ name, size = 18 }) {
  const path = ICONS[name];
  if (!path) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={path} />
    </svg>
  );
}

/** Canonical six-colour Vera spark, ported from Presto Studio's /app UI. */
export function Spark({ size = 22 }) {
  const lengths = [10.8, 9, 11, 9.2, 10.6, 9];
  const colours = [
    '--brand-teal',
    '--brand-green',
    '--brand-orange',
    '--brand-coral',
    '--brand-pink',
    '--brand-purple',
  ];

  return (
    <svg className="spark" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      {lengths.map((outer, index) => {
        const angle = ((-90 + index * 60) * Math.PI) / 180;
        const inner = 3.6;
        return (
          <line
            key={colours[index]}
            x1={12 + inner * Math.cos(angle)}
            y1={12 + inner * Math.sin(angle)}
            x2={12 + outer * Math.cos(angle)}
            y2={12 + outer * Math.sin(angle)}
            style={{ stroke: `var(${colours[index]})` }}
          />
        );
      })}
    </svg>
  );
}

export function SiteThumb({ site, index = 0 }) {
  const palettes = [
    ['#f4efe8', '#c9754f', '#2f4034'],
    ['#eef3ed', '#6b8f7a', '#314139'],
    ['#f5eef5', '#9a63a5', '#433348'],
    ['#edf1f8', '#6c7fb8', '#2e3449'],
  ];
  const palette = palettes[index % palettes.length];

  return (
    <span className="project-thumb" style={{ '--thumb-bg': palette[0], '--thumb-accent': palette[1], '--thumb-ink': palette[2] }}>
      <span className="project-thumb__brand" />
      <span className="project-thumb__headline" />
      <span className="project-thumb__copy" />
      <span className="project-thumb__cta" />
      <span className="visually-hidden">Preview thumbnail for {site.name}</span>
    </span>
  );
}
